/**
 * API Contracts
 *
 * Request/response schemas for all API endpoints.
 * These are the single source of truth for API types shared between
 * backend (validation) and frontend (type safety).
 */

// Common patterns (pagination, errors, envelopes)
export * from './common'

// Domain-specific API contracts
export * from './auth'
export * from './schools'
export * from './users'
export * from './school-users'
export * from './sync'
export * from './groups'
export * from './media'
export * from './feeds'
export * from './content'
export * from './polls'
export * from './calls'
// Only the legacy AI conversation contracts: the parent chat pilot contracts (turns, chat store,
// /internal/ai-chat) are reachable only through the `@school-journey/shared-types/api/ai-chat` subpath (SCH-5216).
export * from './ai-chat/legacy'
export * from './directories'
export * from './schedule'
export * from './system'
export * from './collections'
export * from './mobile-apps'
export * from './operations-events'
export * from './webhook-deliveries'
export * from './agent-runs'
export * from './artifacts'
export * from './kleos-runs'
export * from './investigate'
// Not `./coordination`: the factory's contracts are reachable only through the
// `@school-journey/shared-types/api/coordination` subpath, so no product bundle carries them (SCH-4947).
export * from './fleet-ops'
export * from './home'
export * from './user-tasks'
export * from './user-preferences'
export * from './notifications'
export * from './student-planner'
export * from './pages'
export * from './arbiter'
export * from './app-preview'
export * from './provisioning-runs'
export * from './incidents'
export * from './messaging'
export * from './sections'
export * from './section-schedule'
export * from './spaces'
export * from './events-testing'
export * from './forms'
export * from './agreements'
export * from './skylab'
export * from './catalog'
export * from './enrollment/reconciliation'
export * from './enrollment/readiness-queue'
export * from './enrollment/activity-feed'
export * from './enrollment/candidate-detail'
export * from './enrollment/candidacies'
export * from './enrollment/inquiries'
export * from './enrollment/refresh-sync'
export * from './support/requests'
export * from './support/public-requests'
export * from './synced-events'
export * from './ticketed-events'
export * from './athletics-availability'
export * from './athletics-hub'
export * from './blog'
export * from './docs'
export * from './feedback-board'
export * from './messageable-moderators'
export * from './messageable-section-parents'
export * from './infrastructure'
export * from './internal'
export * from './demo/handoff'
export * from './demo/admin-links'
export * from './demo/app-preview'
export * from './students'
export * from './attendance'
export * from './school-icon-library'
export * from './resource-board'
export * from './browser-session-renewals'
export * from './comms'
